import React from 'react';

class EmptyHeader extends React.Component {
  render() {
    // this is a spacer for the pages that dont have header (320px 20rem;)
    return <div className="empty-header" />;
  }
}

export default EmptyHeader;
